import { Element } from '@xmpp/xml'
import { INBOX_XMLNS, MAM_XMLNS, MUC_LIGHT_AFFILIATIONS } from './constants'

// Primitive getters, these should always be one-level child getters
export const getDelayStanza = (stanza?: Element): Element | undefined => stanza?.getChild('delay')
export const getInboxStanza = (stanza?: Element) => stanza?.getChild('result', INBOX_XMLNS)
export const getFinInboxStanza = (stanza?: Element) => stanza?.getChild('fin', INBOX_XMLNS)
export const getArchiveStanza = (stanza?: Element) => stanza?.getChild('result', MAM_XMLNS)
export const getForwardedStanza = (stanza?: Element) => stanza?.getChild('forwarded')
export const getMessageStanza = (stanza?: Element) => stanza?.getChild('message')
export const getMessageBodyStanza = (stanza?: Element) => stanza?.getChild('body')
const getDisplayedStanza = (stanza?: Element) => stanza?.getChild('displayed')
const getMessageSubjectStanza = (stanza?: Element) => stanza?.getChild('subject')
export const getQueryStanza = (stanza?: Element) => stanza?.getChild('query')

// Complex getters, these should be getters including any kind of more complex logic
// than just getting child
export const getMarkerStanza = (stanza?: Element) =>
  stanza?.getChild('sent') ?? stanza?.getChild('received') ?? getDisplayedStanza(stanza)

// Checkers, these should contain logics to check if stanza is of specific type
export const isMessageStanza = (stanza?: Element) => stanza?.is('message')
const isSubjectStanza = (stanza?: Element) => Boolean(getMessageSubjectStanza(stanza))
export const getStanzaType = (stanza?: Element) => stanza?.getAttr('type')
export const isGroupchatStanza = (stanza?: Element) =>
  isMessageStanza(stanza) &&
  getStanzaType(stanza) === 'groupchat' &&
  !isSubjectStanza(stanza) &&
  !getMarkerStanza(stanza)
export const isGroupchatMarkerStanza = (stanza?: Element) =>
  isMessageStanza(stanza) &&
  getStanzaType(stanza) === 'groupchat' &&
  !isSubjectStanza(stanza) &&
  getMarkerStanza(stanza)

export const isAffiliationsStanza = (stanza?: Element) =>
  Boolean(
    isMessageStanza(stanza) && stanza?.getChild('x')?.getAttr('xmlns') === MUC_LIGHT_AFFILIATIONS
  )

export const isMamAffiliationsStanza = (stanza: Element) =>
  Boolean(isAffiliationsStanza(getMessageStanza(getForwardedStanza(getArchiveStanza(stanza)))))
export const isUserParticipatingInRoom = (stanza?: Element) => {
  const errorStanza = stanza?.getChild('error')
  return errorStanza?.getAttr('code') === '406' && errorStanza?.getAttr('type') === 'modify'
}

// Extractors, these should contain logics to extract data from stanza
export const getDelayStanzaStamp = (stanza?: Element): string | undefined =>
  stanza?.getAttr('stamp')
export const getInboxStanzaUnread = (stanza?: Element): string | undefined =>
  stanza?.getAttr('unread')
export const getMessageBodyStanzaText = (stanza?: Element) => stanza?.getText()
export const getMessageStanzaData = (stanza?: Element) => {
  const id: string | undefined = stanza?.getAttr('id')
  const to: string | undefined = stanza?.getAttr('to')
  const from: string | undefined = stanza?.getAttr('from')

  return { id, to, from }
}
export const getGroupchatStanzaFrom = (stanza?: Element) => {
  const from: string | undefined = stanza?.getAttr('from')
  return from
}
export const getStanzaId = (stanza?: Element) => {
  const id: string | undefined = stanza?.getAttr('id')
  return id
}
export const getArchivedFlag = (stanza?: Element) => stanza?.getChildText('archive') === 'true'
export const getMuteFlag = (stanza?: Element) => stanza?.getChildText('mute') !== '0'
